import React from 'react';

import { usePathname } from 'expo-router';

import { OnboardingScreensModal } from 'components/onboarding-screens-modal';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useUIContext } from 'state/ui';
import { routes } from 'utils/routing';

import { OnboardingProvider } from './onboarding';

export const MaybeShowOnboardingContent = () => {
  const { isUpdateModalOpen } = useUIContext();
  const onboardingEnabled = useFlag(LaunchDarklyFlag.ENABLE_FEATURE_ONBOARDING);
  const pathname = usePathname();

  if (isUpdateModalOpen || !onboardingEnabled || pathname.includes(routes.walmart)) {
    return null;
  }

  return (
    <OnboardingProvider>
      <OnboardingScreensModal />
    </OnboardingProvider>
  );
};
